export default "__VITE_ASSET__Ftjpk3eN__"